module.exports = __webpack_public_path__ + "img/logo-icon.2b32557c.png";